import {getLinkOutParam} from '../utils/linkOutSession';
import {useSearchParams} from '../utils/urlQuery';

/**
 * Hook to get the language param from the URL.
 * @returns The language param from the URL or undefined if it is not present.
 */
export const useLanguageParam = () => {
  const params = useSearchParams();
  const lang = params.get('lang') ?? getLinkOutParam('lang') ?? undefined;
  return lang;
};
